import Menu from '@/global/components/MenuV2'
import { onlyUnique } from '@acme/common'
import { OpcoesExportacaoFolha as Opcoes } from '@acme/core'
import { Checkbox, Divider, Grid, ListItemText } from '@mui/material'
import { FormField, FormFieldSelect } from 'global/components/Form'
import { useAuth } from 'hooks'
import { useEffect, useState } from 'react'
import { useFormContext } from 'react-hook-form'
import { regrasCalculo } from 'service/api'

export default function FormExportacaoTxt({
    podeLancarPagamento,
}: {
    podeLancarPagamento: boolean
}) {
    const { watch, setValue } = useFormContext()
    const [tipoExtras, tipoFaltas]: [number, number] = watch([
        'horasExtras',
        'horasFaltas',
    ])
    const {
        decoded: { cliente: clienteId },
    } = useAuth()
    const { data: regras } = regrasCalculo.useFetch({
        queryParams: {
            clienteId,
        },
    })
    const porcentagens =
        regras
            ?.map(item => item.porcentagens.map(p => p.porcentagem))
            .flat()
            .filter(onlyUnique)
            .sort((a, b) => a - b) ?? []
    const [porcentagensSelecionadas, setPorcentagens] = useState(porcentagens)

    useEffect(() => {
        if (tipoExtras == 1) {
            setValue('porcentagensSelecionadas', '[]')
            setPorcentagens([])
        } else if (tipoExtras == Opcoes.PAGAR) {
            setValue('porcentagensSelecionadas', JSON.stringify(porcentagens))
            setPorcentagens(porcentagens)
        }
    }, [tipoExtras])

    return (
        <>
            <Divider sx={{ mb: 1 }}>Horas extras</Divider>
            <Grid container spacing={1}>
                <Grid item xs={tipoExtras == Opcoes.DESCONTAR ? 10 : 12}>
                    <FormFieldSelect
                        label=""
                        name="horasExtras"
                        options={[
                            {
                                label: 'Apenas gerar o arquivo de exportação',
                                value: Opcoes.NADA.toString(),
                            },
                            {
                                label: 'Lançar pagamento para as horas exportadas',
                                value: Opcoes.PAGAR.toString(),
                                disabled: !podeLancarPagamento,
                            },
                            {
                                label: 'Lançar pagamento para as primeiras X horas',
                                value: Opcoes.DESCONTAR.toString(),
                                disabled: !podeLancarPagamento,
                            },
                        ]}
                    />
                </Grid>
                {tipoExtras == Opcoes.DESCONTAR && (
                    <Grid item xs={2}>
                        <FormField
                            name="horasExtrasPagar"
                            label="Horas"
                            autoComplete="off"
                            options={{
                                blocks: [3, 2],
                                delimiter: ':',
                                numericOnly: true,
                            }}
                        />
                    </Grid>
                )}
                {tipoExtras != Opcoes.NADA && (
                    <Grid item xs={12}>
                        <FormField
                            name="porcentagensSelecionadas"
                            label="Porcentagens a pagar"
                            select
                            SelectProps={{
                                multiple: true,
                                value: porcentagensSelecionadas,
                                onChange: e => {
                                    setValue(
                                        'porcentagensSelecionadas',
                                        JSON.stringify(e.target.value),
                                    )
                                    setPorcentagens(e.target.value as number[])
                                },
                                renderValue: selected => {
                                    const arr = selected as number[]
                                    return porcentagens.length === arr.length
                                        ? 'Todas'
                                        : arr
                                              ?.map(item => item + '%')
                                              .join(', ')
                                },
                            }}
                        >
                            {porcentagens?.map((item, index) => {
                                return (
                                    <Menu.Item key={index} value={item}>
                                        <Checkbox
                                            checked={porcentagensSelecionadas?.includes(
                                                item,
                                            )}
                                        />
                                        <ListItemText primary={item + '%'} />
                                    </Menu.Item>
                                )
                            })}
                        </FormField>
                    </Grid>
                )}
            </Grid>
            <Divider sx={{ mb: 1, mt: 2 }}>Faltas</Divider>
            <Grid container spacing={2}>
                <Grid item xs={tipoFaltas == Opcoes.DESCONTAR ? 10 : 12}>
                    <FormFieldSelect
                        label=""
                        name="horasFaltas"
                        options={[
                            {
                                label: 'Apenas gerar o arquivo de exportação',
                                value: Opcoes.NADA.toString(),
                            },
                            {
                                label: 'Lançar pagamento para todas as horas exportadas',
                                value: Opcoes.PAGAR.toString(),
                                disabled: !podeLancarPagamento,
                            },
                            {
                                label: 'Lançar pagamento para as primeiras X horas',
                                value: Opcoes.DESCONTAR.toString(),
                                disabled: !podeLancarPagamento,
                            },
                        ]}
                    />
                </Grid>
                {tipoFaltas == Opcoes.DESCONTAR && (
                    <Grid item xs={2}>
                        <FormField
                            name="horasFaltasPagar"
                            label="Horas"
                            autoComplete="off"
                            options={{
                                blocks: [3, 2],
                                delimiter: ':',
                                numericOnly: true,
                            }}
                        />
                    </Grid>
                )}
            </Grid>
        </>
    )
}
